import { Outlet } from 'react-router-dom';
import { SideNavbar } from '../components/navigation/SideNavBar/SideNavbar';

export default function RootLayout() {
  return (
    <div className="flex h-screen">
      <div className="bg-secondary flex h-full">
        <SideNavbar />
      </div>
      <div className="flex h-full w-full flex-col overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
